import React, { useState, useEffect, useRef } from "react";
import "../../assets/css/botompanel.css";
import { Link } from "react-router-dom";

function BottomPanel({ wishlistCount = 0, cartCount = 0 }) {
  const [activeTab, setActiveTab] = useState("home");
  const [accountMenuOpen, setAccountMenuOpen] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  // CATEGORY + SUBCATEGORY STATES
  const [expandedCategory, setExpandedCategory] = useState(null);
  const [expandedSub, setExpandedSub] = useState(null);
  const accountRef = useRef(null);

  // ----- FIXED CATEGORY → SUB → SUB-SUB MENU DATA

  const categories = [
    {
      name: "Bath Care",
      sub: [
        {
          name: "Mobiles", sub: ["Samsung", "Apple", "OnePlus"],
        },
        {
          name: "Laptops", sub: ["HP", "Dell", "Macbook"],
        },
        {
          name: "Smart Watches", sub: ["Boat", "Noise", "Apple Watch"],
        },
      ],
    },
    {
      name: "Dustbins",
      sub: [
        { name: "Men", sub: ["Shirts", "Jeans", "Shoes"] },
        { name: "Women", sub: ["Dresses", "Handbags", "Jewelry"] },
        { name: "Kids", sub: ["Clothes", "Toys"] },
      ],
    },
     {
      name: "Floor Covering",
      sub: [
        { name: "Men", sub: ["Shirts", "Jeans", "Shoes"] },
        { name: "Women", sub: ["Dresses", "Handbags", "Jewelry"] },
        { name: "Kids", sub: ["Clothes", "Toys"] },
      ],
    },
    {
      name: "Home Decor",
      sub: [
        { name: "Men", sub: ["Shirts", "Jeans", "Shoes"] },
        { name: "Women", sub: ["Dresses", "Handbags", "Jewelry"] },
        { name: "Kids", sub: ["Clothes", "Toys"] },
      ],
    },
    {
      name: "Kitchen",
      sub: [
        { name: "Men", sub: ["Shirts", "Jeans", "Shoes"] },
        { name: "Women", sub: ["Dresses", "Handbags", "Jewelry"] },
        { name: "Kids", sub: ["Clothes", "Toys"] },
      ],
    },
    {
      name: "Organisers",
      sub: [
        { name: "Men", sub: ["Shirts", "Jeans", "Shoes"] },
        { name: "Women", sub: ["Dresses", "Handbags", "Jewelry"] },
        { name: "Kids", sub: ["Clothes", "Toys"] },
      ],
    },
    {
      name: "tableware",
      sub: [
        { name: "Men", sub: ["Shirts", "Jeans", "Shoes"] },
        { name: "Women", sub: ["Dresses", "Handbags", "Jewelry"] },
        { name: "Kids", sub: ["Clothes", "Toys"] },
      ],
    },
    {
      name: "yogamat",
      sub: [
        { name: "Men", sub: ["Shirts", "Jeans", "Shoes"] },
        { name: "Women", sub: ["Dresses", "Handbags", "Jewelry"] },
        { name: "Kids", sub: ["Clothes", "Toys"] },
      ],
    },
  ];

  // ----- BOTTOM NAV ITEMS --------

  const navItems = [
    { key: "home", label: "Home", icon: "bi-house", fillIcon: "bi-house-fill" },
    { key: 'category', label: 'Category', icon: 'bi-grid', fillIcon: 'bi-grid-fill', path:'' },
    {
      key:"Wishlist",
      label:"Wishlist",
      icon:"bi-heart",
      fillIcon:"bi-heart-fill",
      count:wishlistCount,
      path:"/wishlist",
    },
    {
      key:"Cart",
      label:"Cart",
      icon:"bi-cart",
      fillIcon:"bi-cart-fill",
      count: cartCount,
      path:"/checkout/cart",
    },
    { key: "account", label: "My Account", icon: "bi-person", fillIcon: "bi-person-fill" },
  ];

  // CLICK OUTSIDE ACCOUNT DROPDOWN

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (accountRef.current && !accountRef.current.contains(event.target)) {
        setAccountMenuOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // CATEGORY ACCORDION HANDLER

  const toggleCategory = (name) => {
    setExpandedCategory((prev) => (prev === name ? null : name));
    setExpandedSub(null); // close all submenus when switching category
  };

  // SUBCATEGORY ACCORDION HANDLER

  const toggleSub = (name) => {
    setExpandedSub((prev) => (prev === name ? null : name));
  };

  // BOTTOM PANEL TAB HANDLER

  const handleTabClick = (key) => {
    if (key === "home") {
      setMenuOpen(true);
      return;
    }
    if (key === "account") {
      setAccountMenuOpen((prev) => !prev);
    }
    setActiveTab(key);
  };
  return (
    <>
      {/*--------- LEFT SLIDE MENU -------*/}

      <div className={`fixed top-0 left-0 h-full w-64 bg-white shadow-2xl z-[999] transform transition-transform duration-300 ${
          menuOpen ? "translate-x-0" : "-translate-x-full"
        }`}
         >
        <div className="flex items-center justify-between p-2 border-b" style={{ background:"rgb(227 227 227)", padding:"12px 19px !important"}}>
          <h2 className="text-lg font-semibold"> Menu </h2>
          <button onClick={() => setMenuOpen(false)}>
            <i className="bi bi-x-lg text-xl"></i>
          </button>
        </div>

        {/*----- CATEGORY LIST -----------*/}

        <ul className="p-4 space-y-3" style={{ overflowY:"auto", height:"530px"}}>
          {categories.map((cat) => (
            <li key={cat.name} className="border-b pb-2">

              {/*------ CATEGORY HEADER -----*/}
              
              <div
                className="flex justify-between items-center cursor-pointer font-semibold py-2"
                onClick={() => toggleCategory(cat.name)}
                >
                <span>{cat.name}</span>
                <i
                  className={`bi ${
                    expandedCategory === cat.name ? "bi-chevron-up" : "bi-chevron-down"
                  }`}
                ></i>
              </div>

              {/*------ SUBCATEGORY LIST ------*/}

              {expandedCategory === cat.name && (
                <ul className="pl-4 text-gray-600 space-y-2 animate-slideDown">
                  {cat.sub.map((subItem) => (
                    <li key={subItem.name}>
                        {/*------- SUBCATEGORY HEADER -------*/}
                      <div
                        className="flex justify-between items-center cursor-pointer py-1"
                        onClick={(e) => {
                          e.stopPropagation();
                          toggleSub(subItem.name);
                          }}
                        >
                        <span>{subItem.name}</span>
                        <i
                          className={`bi ${
                            expandedSub === subItem.name
                              ? "bi-chevron-up"
                              : "bi-chevron-right"
                          }`}
                        ></i>
                      </div>

                      {/*----- SUB-SUBCATEGORY LIST -----*/}

                      {expandedSub === subItem.name && (
                        <ul className="pl-4 space-y-1 text-gray-500">
                          {subItem.sub.map((subsub) => (
                            <li
                              key={subsub}
                              className="py-1 cursor-pointer hover:text-black"
                              onClick={(e) => {
                                e.stopPropagation();
                                console.log("Selected:", subsub);
                              }}
                              >
                              {subsub}
                            </li>
                          ))}
                        </ul>
                      )}
                    </li>
                  ))}
                </ul>
              )}
            </li>
          ))}
        </ul>
      </div>

      {/*------------------ BACKDROP ---------------- */}

      {menuOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-40 z-[998]"
          onClick={() => setMenuOpen(false)}
        ></div>
      )}

      {/*----------- BOTTOM PANEL --------------*/}

      <div className="bottom-panel fixed bottom-0 w-full bg-white shadow-lg z-50">
        <ul className="flex justify-around items-center relative">
          {navItems.map((item) => (
            <li
              key={item.key}
              className={`bottom-nav-item text-center relative ${
                activeTab === item.key ? "text-black-600" : "text-gray-500"
              }`}
              onClick={() => handleTabClick(item.key)}
              ref={item.key === "account" ? accountRef : null}
              >
              <Link to={item.path} className="flex flex-col items-center relative">
                <div className="icon mb-1 relative">
                  <i
                    className={`bi ${
                      activeTab === item.key ? item.fillIcon : item.icon
                    } text-lg`}
                  ></i>
                  {"count" in item && (
                    <span className="absolute -top-1 -right-2 bg-red-500 text-white text-[10px] font-bold rounded-full px-1.5 py-0.5">
                      {item.count}
                    </span>
                  )}
                </div>
                    <span className="text-xs font-medium">{item.label}</span>
              </Link>

              {/*------------ ACCOUNT DROPDOWN --------------*/}
              
              {item.key === "account" && accountMenuOpen && (
                <div className="absolute bottom-full mb-2 left-1/2 transform -translate-x-1/2 bg-white border rounded-lg shadow-lg w-36 text-sm z-10">
                  <ul className="flex flex-col py-1">
                    <li>
                      <Link
                        to="/login"
                        className="flex items-center gap-2 px-4 py-2 hover:bg-gray-100"
                         >
                        <i className="bi bi-box-arrow-in-right"></i>
                        <span> Sign In </span>
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/profile"
                        className="flex items-center gap-2 px-4 py-2 hover:bg-gray-100"
                         >
                           <i className="bi bi-people"></i>
                           <span> My Profile </span>
                      </Link>
                    </li>
                  </ul>
                </div>
              )}
            </li>
          ))}
        </ul>
      </div>

    </>
  );
}
export default BottomPanel;
